// @ts-nocheck
import genRequest from "includes/request";

class RssServiceImpl {
	getRssFeeds(companyId) {
		return genRequest("rss/company/" + companyId);
	}
	postRssFeed(data) {
		return genRequest("rss", data, "post");
	}
	deteleRssFeed(id) {
		return genRequest("rss/" + id, null, "delete");
	}
	updateRssFeed(id, data) {
		return genRequest("rss/" + id, data, "put");
	}
	getFeedsFromUrl(url) {
		// { feedTitle: feedUrl } of the feeds offered by a site or feed URL
		return genRequest(`rss/discover`, { url }, "post");
	}
	getAllPostsRssFeeds(companyId) {
		return genRequest("rss/company/" + companyId + "/as-posts");
	}
	getAllPostsRssFeedsByUrl(url) {
		return genRequest("rss/feed-as-posts", { rssFeedUrl: url }, "post");
	}
}

export const RssService = new RssServiceImpl();
